module.exports = __webpack_public_path__ + "a38aba3a039bdf39d4d52b530441b000.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/gear.png
// module id = 3009
// module chunks = 0